"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var PlayerFavoriteGamesList = /** @class */ (function (_super) {
    __extends(PlayerFavoriteGamesList, _super);
    function PlayerFavoriteGamesList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Игрок',
                key: "v-" + _this.props.dataFavoriteGames.dk_key,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.player.login));
                },
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.dataFavoriteGames.dk_brand_title,
                key: _this.props.dataFavoriteGames.dk_brand_title,
                width: 200,
            }, {
                title: 'Шлюз',
                dataIndex: _this.props.dataFavoriteGames.dk_gws_gameprovider_title,
                key: _this.props.dataFavoriteGames.dk_gws_gameprovider_title,
                width: 200,
            }, {
                title: 'Игра',
                dataIndex: _this.props.dataFavoriteGames.dk_gws_gameprovider_game_title,
                key: _this.props.dataFavoriteGames.dk_gws_gameprovider_game_title,
                width: 200,
            }, {
                title: 'Добавлено',
                dataIndex: _this.props.dataFavoriteGames.dk_date_added,
                key: _this.props.dataFavoriteGames.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                },
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
        return _this;
    }
    PlayerFavoriteGamesList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    PlayerFavoriteGamesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataFavoriteGames.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
        }, function () {
            _this.props.dataFavoriteGames.LoadData(_this.props.player.key);
        });
    };
    PlayerFavoriteGamesList.prototype.componentWillUnmount = function () {
        this.props.dataFavoriteGames.UnSubscribe(this.SID);
    };
    PlayerFavoriteGamesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.dataFavoriteGames.LoadData(_this.props.player.key);
            });
        }
    };
    PlayerFavoriteGamesList.prototype.onDeleteClick = function (record) {
        this.props.dataFavoriteGames.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0418\u0433\u0440\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.gws_gameprovider_game_title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    PlayerFavoriteGamesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.dataFavoriteGames.LoadData(_this.props.player.key, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerFavoriteGamesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.dataFavoriteGames.LoadData(this.props.player.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerFavoriteGamesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Добавить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]")));
                } })));
    };
    return PlayerFavoriteGamesList;
}(React.Component));
exports.default = PlayerFavoriteGamesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/favorite_games/PlayerFavoriteGamesList.tsx
// module id = 1927
// module chunks = 0